/**
 * User: n.gorte
 * Date: 18.09.2020
 * Time: 09:44
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { translation } from 'plugin/liferay-widgets-react-web';
import { getEventType } from '../../utils/event-type-util';
import { EVENT_TYPE_UPDATE } from '../../constants/Constants';
import BusinessObjectLink from '../BusinessObjectLink';
import { NewValueTd, OldValueTd, PropertyTd } from './TableElems';

export const ChangeRecordBusinessObjectRenderer = ({ propName, changeRecord, className }) => {
    const eventType = getEventType(changeRecord);
    const { changes } = changeRecord;
    const change = changes[propName];

    if(!change) {
        return null;
    }

    const { oldValue, newValue } = change;

    return (
        <tr>
            <PropertyTd>
                {translation.trans(propName)}
            </PropertyTd>
            {
                eventType === EVENT_TYPE_UPDATE &&
                <OldValueTd>
                    {
                        Number.isInteger(oldValue) && oldValue > 0 &&
                        <BusinessObjectLink
                            className={className}
                            classPK={oldValue}
                        />
                    }
                    {
                        (!Number.isInteger(oldValue)  || oldValue === 0) && '---'
                    }
                </OldValueTd>
            }
            <NewValueTd>
                <BusinessObjectLink
                    className={className}
                    classPK={newValue}
                />
            </NewValueTd>
        </tr>
    );
};

ChangeRecordBusinessObjectRenderer.propTypes = {
    propName: PropTypes.string,
    changeRecord: PropTypes.object,
    className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/ChangeRecordBusinessObjectRenderer.jsx